import List from "@/components/list";
import Bus from "./Bus.js";
//import router from "@/router";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  const review = args.listeners["review"] || function () { };
  function handleDelete({ row }) {
    Bus.$emit("deleteComment", row.uuid);
  }
  // function handleUpdate({ row }) {
  //   Bus.$emit("updateComment", row);
  // }
  function showComment({ row }) {
    Bus.$emit("showComment", row);
  }
  function hideComment({ row }) {
    Bus.$emit("hideComment", row);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      // ["icon-edit", "编辑", () => handleUpdate(vo), "comment:update"],
      ["icon-delete", "删除", () => handleDelete(vo), "comment:delete"]
    ];
    if (vo.row.displayStatus == 1) {
      dealConf.push([
        "icon-hide",
        "隐藏",
        () => hideComment(vo),
        "comment:display"
      ]);
    } else {
      dealConf.push([
        "icon-show",
        "显示",
        () => showComment(vo),
        "comment:display"
      ]);
    }

    if (vo.row.isReview === 1) {
      dealConf.push([
        "icon-message",
        "复核",
        () => review(vo.row.uuid),
        "comment:review"
      ])
    }

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "评论内容",
      prop: "commentContent",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "资源名称",
      prop: "bizName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "状态",
      prop: "displayStatusName",
      minWidth: "100"
    },
    {
      label: "是否人工复核",
      prop: "isReviewName",
      minWidth: "100"
    },
    {
      label: "评论人",
      prop: "createUserName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "评论时间",
      prop: "createDate",
      minWidth: "130"
    },
    {
      label: "操作",
      minWidth: "120",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
